<template>
    <div 
        class="modal fade"
        id="addCustomerModal"
        tabindex="-1"
        aria-labelledby="addCustomer"
        aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addCustomer">
                        {{isEdit ? 'Edit' : 'Add'}} Customer
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <form @submit.prevent="submit">
                <div class="modal-body">
                    <div class="col-md-12 text-start">
                        <label for="company_name" class="form-label">Name:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.company_name ? true : false}" id="company_name" v-model="form.company_name" autofocus aria-describedby="nameFeedback" required>
                            <div v-if="errors.company_name" id="nameFeedback" class="invalid-feedback">
                                {{errors.company_name}}
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 text-start">
                        <label for="user_id" class="form-label">Account Manager:</label>
                        <div class="input-group has-validation">
                            <!--<input type="tel" :class="{'form-control':true, 'is-invalid':errors.user_type_id ? true : false}" id="phone" v-model="form.user_type_id" aria-describedby="phoneFeedback" required>
                            <div  v-if="errors.user_type_id" id="phoneFeedback" class="invalid-feedback">
                                {{errors.user_type_id}}
                            </div>-->

                            <select :class="{'form-select':true, 'is-invalid':errors.user_id ? true : false}" id="user_id" v-model="form.user_id" required>
                                <option v-for="user in users" :key="user.id" :value="user.id">{{ user.name }}</option>
                            </select>
                            <div  v-if="errors.user_id" id="phoneFeedback" class="invalid-feedback">
                                {{errors.user_id}}
                            </div>
                        </div>
                    </div>  
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                    >
                        Cancel
                    </button>
                    <button type="submit" class="btn btn-primary" :disabled="form.processing">
                        {{isEdit ? 'Update' : 'Save'}}
                    </button>
                </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap';

export default {
    props: {
        customer: Object,
        users: Array,
        isEdit: Boolean
    },
    data() {
        return {
            modal: null,
            form: this.$inertia.form({
                company_name: this.customer ? this.customer.company_name : "" ,
                user_id: this.customer ? this.customer.user_id : ""
            }),
            errors: {
               company_name: null,
               user_id: null 
            },
        };
    },
    mounted() {
        var modalEl = document.getElementById('addCustomerModal')
        this.modal = new Modal(modalEl)
        this.modal.show();
        
        modalEl.addEventListener('hidden.bs.modal',  (event) => {
            this.$emit('modelStatusChanged',false)
        })
    },
    methods: {
        close(){
            //this.isOpen = false
        },
        submit() {
            let route = this.isEdit ? this.route("customers.update",this.customer.id) : this.route("customers.store")
            let method = this.isEdit ? 'patch' : 'post'
            this.form[this.isEdit ?'patch' : 'post'](route, {
                onError: (errors) => {
                    
                    if (Object.entries(errors).length !== 0) {
                        var toast = {
                            bg: "bg-danger",
                        };

                        if (errors.hasOwnProperty("company_name")) {
                            toast.message = errors.company_name;
                            this.errors.company_name = errors.company_name;
                        }

                        if (errors.hasOwnProperty("user_id")) {
                            toast.message = errors.user_id;
                            this.errors.user_id = errors.user_id;
                        }
                    }
                }, 
                onSuccess: () => {
                    this.form.reset();
                    this.modal.hide();

                }
            });
        },
    },
};
</script>
